<template>
  <div class="asahi-counter" :class="{'inModal':isInModal}">
    <AsahiButton
      v-if="showCounterButton"
      class="asahi-counter-button secondary-border-none button-space"
      :class="m-0"
      color="secondary-border-none"
      :disabled="(quantity === minCount) || setDisable"
      @click="_decrement"
      rigid="square"
    >-</AsahiButton>
    <div class="asahi-input-border" :class="{'border-left-right': showCounterButton }">
      <input
        class="asahi-counter-quantity"
        maxlength="3"
        size="3"
        align-center
        :disabled="setDisable"
        v-model.number="quantity"
        :class="m-0"
        @blur="_onBlur"
        @keyup="_manageKeyPress"
        @click="removeBorderStyle"
      />
    </div>
    <AsahiButton
      v-if="showCounterButton"
      class="asahi-counter-button secondary-border-none button-space"
      color="secondary-border-none"
      :disabled="(quantity === maxCount) || setDisable"
      @click="_increment"
      rigid="square"
    >+</AsahiButton>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import _debounce from 'lodash/debounce'
import AsahiButton from './AsahiButton.vue'

export default defineComponent({
  components: {
    AsahiButton
  },
  props: {
    modelValue: {
      type: Number,
      required: true
    },
    minCount: {
      type: Number,
      default: 0
    },
    maxCount: {
      type: Number,
      default: 99
    },
    isInModal: {
      type: Boolean,
      default: false
    },
    setDisable: {
      type: Boolean,
      default: false
    },
    showCounterButton: {
      type: Boolean,
      default: true
    },
    step: {
      type: Number,
      default: 1
    }
  },
  emits: ['update:modelValue'],
  data () {
    return {
      canEmit: true,
      quantity: this.modelValue
    }
  },
  watch: {
    modelValue (value) {
      this.quantity = value
    }
  },
  methods: {
    _increment () {
      if (!this.canEmit) return
      if (this.quantity < this.maxCount) {
        this.quantity += this.step
        this._emitValue()
      }
    },
    _decrement () {
      if (!this.canEmit) return
      if (this.quantity > this.minCount) {
        this.quantity -= this.step
        if (this.quantity <= 0) {
          this.quantity = 0
        }
        this._emitValue()
        this.$emit('decrement-event', event)
      }
    },
    _changeValue (event) {
      const value = parseInt(event.target.value, 10)
      if (!isNaN(value) && value >= this.minCount && value <= this.maxCount) {
        this.quantity = value
        this._emitValue()
      }
    },
    _onBlur (event) {
      if (!this.canEmit) return
      this.canEmit = false
      const value = event.target.value ? parseInt(event.target.value, 10) : 0
      if (!isNaN(value) && value >= this.minCount && value <= this.maxCount) {
        this.quantity = value
        setTimeout(() => {
          this.canEmit = true
          this.$emit('update:modelValue', this.quantity)
        }, 300)
      } else {
        this.canEmit = true
      }
      this.$emit('keyup-event', event)
    },
    _emitValue: _debounce(function () {
      this.$emit('update:modelValue', this.quantity)
    }, 300),
    _manageKeyPress (event) {
      if (event.key === 'Enter') {
        if (!this.canEmit) return
        this.canEmit = false
        const value = event.target.value ? parseInt(event.target.value, 10) : 0
        if (!isNaN(value) && value >= this.minCount && value <= this.maxCount) {
          this.quantity = value
          event.target.blur()
          this._handleEnterPress(event)
        } else {
          this.canEmit = true
        }
        // event.preventDefault()
        this.$emit('keyup-event', event)
      }
      /* commenting this code as used in minicart to add value on in key press
      if (!this.showCounterButton) {
        this._changeValue(event)
      }
      */
      // this._changeValue(event)
    },
    _handleEnterPress (event) {
      // Call the desired method or perform an action
      this._changeValue({ target: { value: this.quantity } })
      setTimeout(() => {
        this.canEmit = true
      }, 300)
    },
    removeBorderStyle () {
      event.target.style.border = 'none'
    }
  }
})
</script>

<style scoped lang='scss'>
.asahi-counter {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.inModal {
  @include media-breakpoint-down(lg) {
    .asahi-counter-button{
      padding: 10px 50px;
      font-size: 22px;
    }

    .asahi-input-border {
      padding: 10px 30px;
    }
  }
}

.asahi-input-border {
  text-align: center;
  padding: 5px;
}

.border-left-right {
  border-left: 1px solid $border-grey;
  border-right: 1px solid $border-grey;
}

.asahi-counter-quantity {
  border: none;
  width: 35px;
  text-align: center;
}

.asahi-counter-quantity:focus {
  border: none;
  border-radius: none;
  width: 35px;
  text-align: center;
}

@media (max-width: $breakpoint-sm) {
  .button-space {
    padding: 10px 12px;
  }
}
</style>
